import { Request, BaseApiUrl } from "./api";
// 施工配比模块
// 列表
export const getProdRecipeListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdRecipe/get`, { params: params });
};
//编辑
export const editProdRecipe = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdRecipe/put`, params);
};
//新增
export const addProdRecipe = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdRecipe/post`, params);
};
//批量删除
export const batchDeleteProdRecipe = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdRecipe/BatchDelete`, params);
};
// export const batchDeleteProdRecipe = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/ProdRecipe/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
//实际配比所需基础数据
export const getProdRecipeBaseData = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdRecipe/GetConsultRecipeBaseData`, { params: params });
};
//获取施工配比详情
export const getProdRecipeDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdRecipe/Detail`, { params: params });
};
// 上传配比
export const sendRecipe = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdRecipe/SendRecipe`, { params: params });
};
// 历史列表
export const getHistryByPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdRecipe/GetHistry`, { params: params });
};